export const reduxKey = '@@pwa';
export const DEFAULT_PUSH_SUBSCRIPTIONS = {
    note: true,
    commentReply: true,
    watcher: true,
    mention: true,
    favourite: true,
    favouriteMilestone: false
};

//# sourceMappingURL=constants.js.map